// Copyright (c) Tangible It, Mexico. All rights reserved.
// Licensed under the MIT License.

import React from "react";
import Controls from "./Controls/Controls";
import { Flex, Loader } from "@fluentui/react-northstar";
import { withTranslation } from "react-i18next";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Header from "../../../../components/Header/Header";
import Subjects from "./Subjects/Subjects";
import AssignmentList from "./AssignmentList/AssignmentList";
import AssignmentSubmission from "./AssignmentSubmissionPage/AssignmentSubmissionPage";
import StudentSubmissionContext from "../../../../context/StudentSubmissionContext";
import Todos from "./Todos";

import "./StudentAssignment.scss";
import "./Home.css";
import { Subscription } from "../../../../components/Subscription/Subscription";
import { StorageRequestDialog } from "../../../../components/Storage/StorageRequestDialog";

const url = process.env.REACT_APP_EP_URL;

const v = new Date(new Date().setHours(0, 0, 0, 0));
// const v = new Date(new Date().setUTCHours(0,0,0,0));
let headers;
class StudentAssignmentHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lessions: [],
      records: [],
      selectedLesson: null,
      showLesson: [],
      showRecords: [],
      showRecordsAnalytics: {
        virtual: 0,
        total: 0,
        present: 0,
        absent: 0,
        late: 0,
        justification: 0,
      },
      showTopic: false,
      showNote: false,
      selectedDate: v.toISOString(),
      selectedClass: null,
      selectedTeacher: null,
      response: {},
      checkAll: false,
      checkedRecords: [],
      checkedRecordsMode: [],
      onLine: null,
      load: false,
      dialog: false,
      accDlg: false,
      selectedLessonType: false,
      isCompactMode: false,
      isSmall: false,
      isSubscribed: false,
      isExpire: false,
      isShowControl: window.innerWidth > 767,
      isStorageRequestDialogOpen: false,
    };
  }

  componentDidMount() {
    if (this.props.user?.dbData?.dayRemaining <= 0) {
      this.setState({
        dialog: false,
        isExpire: true,
      });
    }
    if (this.props.user?.storage == 0) {
      this.setState({ isStorageRequestDialogOpen: true });
    }
  }

  toggleControl = () => {
    this.setState({ isShowControl: !this.state.isShowControl });
  };

  render() {
    return (
      <StudentSubmissionContext>
        <div className="student-assignment">
          <div className="Attendance s-ctr">
            <div
              style={{
                position: "relative",
              }}
            >
              <StorageRequestDialog
                handleClose={() => {
                  this.setState({ isStorageRequestDialogOpen: false });
                }}
                handleOk={() => {
                  console.log("Request");
                }}
                open={this.state.isStorageRequestDialogOpen}
                user={this.props.user}
              />

              {!this.state.isExpire && this.state.isShowControl && (
                <Controls
                  state={{
                    ...this.state,
                    ...{ accessToken: this.props.user.accessToken },
                  }}
                  user={this.props.user}
                  showExport={true}
                  subjectSearch={true}
                />
              )}
            </div>
            <div
              style={{
                overflow: "auto",
                backgroundColor: "white",
              }}
            >
              {this.state.load ? (
                <div style={{ flexGrow: 1 }}>
                  <Loader size="medium" style={{ paddingTop: "50px" }} />
                </div>
              ) : !this.state.load && this.state.isExpire ? (
                <Subscription
                  pageName="assignment"
                  isExpire={this.state.isExpire}
                  role={this.props.user.role}
                />
              ) : (
                <Flex gap="gap.medium" wrap className="container2 d-sm-center">
                  <Flex gap="gap.medium" wrap>
                    <div
                      className="student-table-wrapper w-100"
                      style={{
                        maxHeight: "calc(100vh - 180px)",
                        overflow: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      {/* <BrowserRouter> */}
                      {["/", "/assignments/"].map((path) => {
                        return (
                          <Switch key={path}>
                            <Route
                              path={path}
                              key={path}
                              exact={true}
                              render={(props) => (
                                <Subjects
                                  {...props}
                                  {...this.props}
                                  {...this.state}
                                />
                              )}
                            />
                            <Route
                              path={`${path}pending-assignments`}
                              key={`${path}pending-assignments`}
                              exact={true}
                              render={(props) => (
                                <Todos
                                  {...props}
                                  {...this.props}
                                  {...this.state}
                                />
                              )}
                            />
                            <Route
                              path={`${path}:subjectCode/assignments`}
                              key={`${path}:subjectCode/assignments`}
                              exact={true}
                              component={(props) => (
                                <AssignmentList
                                  {...props}
                                  {...this.props}
                                  {...this.state}
                                />
                              )}
                            />
                            <Route
                              path={`${path}:subjectCode/assignments/:assignmentId`}
                              key={`${path}:subjectCode/assignments/:assignmentId`}
                              exact={!location.pathname.includes("/rubric")}
                              component={(props) => (
                                <AssignmentSubmission
                                  {...this.props}
                                  {...this.state}
                                  {...props}
                                />
                              )}
                            />
                          </Switch>
                        );
                      })}
                      {/* </BrowserRouter> */}
                    </div>
                  </Flex>
                </Flex>
              )}
            </div>
          </div>
        </div>
      </StudentSubmissionContext>
    );
  }
}
export default withTranslation()(StudentAssignmentHome);
